export default __webpack_public_path__ + "static/media/TDS_transaction_details.73868987.xlsx";